import { FieldReadFunction, TypePolicy } from "@apollo/client";

const create =
  (name: string): FieldReadFunction =>
  (_, { args, toReference }) => {
    const { id } = args;

    if (!id) {
      return;
    }

    return toReference({ __typename: name, id: id.toString() });
  };

const Query: TypePolicy = {
  fields: {
    bookingById: create("Booking"),
    consultantById: create("Consultant"),
    customerById: create("Customer"),
    getBookingGroup: create("BookingGroup"),

    invoiceByNumber: (_, { args, toReference }) => {
      const { number } = args;

      if (!number) {
        return null;
      }

      return toReference({ __typename: "Invoice", InvoiceNumber: number });
    },
    consultantEvents: {
      keyArgs: ["consultantId", "type"],
      merge(existing, incoming, { args: { skip = 0 } }) {
        // Slicing is necessary because the existing data is
        // immutable, and frozen in development.
        const merged = existing ? existing.slice(0) : [];
        for (let i = 0; i < incoming.length; ++i) {
          merged[skip + i] = incoming[i];
        }
        return merged;
      }
    }
  }
};

export default { Query };
